import { EasePattern } from './models/ease-pattern';
var noop = function () { };
var defaultSmoothScrollDuration = 800;
export var smoothScroll = function (element, options) {
    if (options === void 0) { options = {}; }
    var duration = options.duration || defaultSmoothScrollDuration;
    var offset = options.offset || 0;
    var easing = options.easing || EasePattern.EaseInOutQuart;
    var callbackBefore = options.callbackBefore || noop;
    var callbackAfter = options.callbackAfter || noop;
    var container = document.getElementById(options.containerId || '');
    var getScrollLocation = function () {
        if (container) {
            return container.scrollTop;
        }
        if (window.pageYOffset) {
            return window.pageYOffset;
        }
        else {
            return document.documentElement.scrollTop;
        }
    };
    var getEasingPattern = function (type, time) {
        switch (type) {
            case EasePattern.EaseInQuad:
                // accelerating from zero velocityk
                return time * time;
            case EasePattern.EaseOutQuad:
                // decelerating to zero velocity
                // tslint:disable-next-line: no-magic-numbers
                return time * (2 - time);
            case EasePattern.EaseInOutQuad:
                // acceleration until halfway, then deceleration
                // tslint:disable-next-line: no-magic-numbers
                return time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time;
            case EasePattern.EaseInCubic:
                // accelerating from zero velocity
                return time * time * time;
            case EasePattern.EaseOutCubic:
                // decelerating to zero velocity
                return --time * time * time + 1;
            case EasePattern.EaseInOutCubic:
                // acceleration until halfway, then deceleration
                // tslint:disable-next-line: no-magic-numbers
                return time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1;
            case EasePattern.EaseInQuart:
                // accelerating from zero velocity
                return time * time * time * time;
            case EasePattern.EaseOutQuart:
                // decelerating to zero velocity
                return 1 - --time * time * time * time;
            case EasePattern.EaseInOutQuart:
                // acceleration until halfway, then deceleration
                // tslint:disable-next-line: no-magic-numbers
                return time < 0.5 ? 8 * time * time * time * time : 1 - 8 * --time * time * time * time;
            case EasePattern.EaseInQuint:
                // accelerating from zero velocity
                return time * time * time * time * time;
            case EasePattern.EaseOutQuint:
                // decelerating to zero velocity
                return 1 + --time * time * time * time * time;
            case EasePattern.EaseInOutQuint:
                // acceleration until halfway, then deceleration
                // tslint:disable-next-line: no-magic-numbers
                return time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * --time * time * time * time * time;
            default:
                return time;
        }
    };
    var getEndLocation = function (targetElement) {
        var location = 0;
        if (targetElement.offsetParent) {
            do {
                location += targetElement.offsetTop;
                targetElement = targetElement.offsetParent;
            } while (targetElement);
        }
        location = Math.max(location - offset, 0);
        return location;
    };
    window.setTimeout(function () {
        var timeLapsedStep = 16;
        var startLocation;
        var endLocation;
        var timeLapsed;
        var distance;
        var percentage;
        var position;
        var scrollHeight;
        var internalHeight;
        var runAnimation;
        var calculate = function () {
            startLocation = getScrollLocation();
            endLocation = getEndLocation(element);
            timeLapsed = 0;
            distance = endLocation - startLocation;
        };
        var isBottom = function () {
            return (window.innerHeight + window.pageYOffset) >= document.documentElement.scrollHeight;
        };
        var stopAnimation = function () {
            var currentLocation = getScrollLocation();
            internalHeight = window.innerHeight + currentLocation;
            scrollHeight = container ? container.scrollHeight : document.documentElement.scrollHeight;
            if (position === endLocation || currentLocation === endLocation || internalHeight > scrollHeight) {
                if (!isBottom() && position !== getEndLocation(element)) {
                    calculate();
                    return;
                }
                clearInterval(runAnimation);
                callbackAfter(element);
            }
        };
        var animateScroll = function () {
            timeLapsed += timeLapsedStep;
            percentage = timeLapsed / duration;
            percentage = percentage > 1 ? 1 : percentage;
            position = startLocation + distance * getEasingPattern(easing, percentage);
            if (container) {
                container.scrollTop = position;
            }
            else {
                window.scrollTo(0, position);
            }
            stopAnimation();
        };
        callbackBefore(element);
        calculate();
        runAnimation = window.setInterval(animateScroll, timeLapsedStep);
    }, 0);
};
